/**
 * Normalize a response name for duplicate detection and searching.
 */
export const normalizeResponseName = (name) =>
  (name ?? '').trim().toLocaleLowerCase('sk');

/**
 * Sources available for prefilling collection responses.
 */
export const RESPONSE_SOURCES = Object.freeze({
  TEACHING_STAFF: 'teachingStaff',
  SUBJECTS: 'subjects',
});
